import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { toast } from "sonner";
import { getPushState, subscribePush, unsubscribePush } from "../lib/push";

const isIosNotInstalled = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  !window.matchMedia("(display-mode: standalone)").matches &&
  !window.navigator.standalone;

export const PushToggle = ({ label = "Notifiche push" }) => {
  const [state, setState] = useState("off");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPushState().then(setState);
  }, []);

  if (state === "unsupported") return null;

  if (isIosNotInstalled()) {
    return (
      <p className="text-xs text-ink-soft" data-testid="push-ios-hint">
        Installa l'app NEED dalla home del telefono per attivare le notifiche.
      </p>
    );
  }

  const toggle = async () => {
    setBusy(true);
    try {
      if (state === "on") {
        await unsubscribePush();
        setState("off");
        toast.success("Notifiche disattivate");
      } else {
        await subscribePush();
        setState("on");
        toast.success("Notifiche attive: ti avvisiamo su ordini e offerte");
      }
    } catch {
      toast.error("Attivazione non riuscita. Controlla i permessi del browser.");
      setState(await getPushState());
    } finally {
      setBusy(false);
    }
  };

  if (state === "denied") {
    return (
      <p className="flex items-center gap-2 text-xs text-ink-soft" data-testid="push-denied-hint">
        <BellOff className="h-4 w-4" /> Notifiche bloccate dal browser: riattivale dalle impostazioni del sito.
      </p>
    );
  }

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid="push-toggle-button"
      className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors ${
        state === "on"
          ? "border-sage/40 bg-sage/15 text-sage"
          : "border-ink/15 text-ink hover:bg-ink hover:text-cream"
      } disabled:opacity-60`}
    >
      {state === "on" ? <BellRing className="h-4 w-4" /> : <Bell className="h-4 w-4" />}
      {busy ? "Attendo…" : state === "on" ? `${label} attive` : `Attiva ${label.toLowerCase()}`}
    </button>
  );
};
